import { BaseBusinessService } from "services/mms/external-api/business/base-business-service"
import { SessionsServiceInterface } from "interfaces/sessions-service.ts"
import { ExportFilterSession } from "types/sessions"

export class BusinessSessionsService
    extends BaseBusinessService
    implements SessionsServiceInterface
{
    useGetMonthConsumption(timestamp: string) {
        return this.get({ endpoint: `/${timestamp}` })
    }
    useGetSessions(filter: ExportFilterSession | null) {
        if (filter?.filter?.date_to === Number.MAX_SAFE_INTEGER)
            filter.filter.date_to = null // éviter de passer une date infinie
        return this.post({ endpoint: '', options: { body: filter } })
    }

    useGetTotalRefillSession() {
        return this.get({ endpoint: '' })
    }

    useGetAverageKilowatt() {
        return this.get({ endpoint: '' })
    }

    useGetTotalKilowatt() {
        return this.get({ endpoint: '' })
    }

    useGetAverageTime() {
        return this.get({ endpoint: '' })
    }
}
